import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/akm.png'


const _withScopeId = n => (_pushScopeId("data-v-1b232100"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "userLayout",
  class: /*#__PURE__*/_normalizeClass(['user-layout-wrapper'])
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"top\" data-v-1b232100><div class=\"header\" data-v-1b232100><a href=\"/\" data-v-1b232100><img src=\"" + _imports_0 + "\" class=\"logo\" alt=\"logo\" data-v-1b232100><span class=\"title\" data-v-1b232100>CDMS账号管理系统</span></a></div></div><div class=\"desc\" data-v-1b232100></div>", 2)
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_view),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, " Copyright © 2023-" + _toDisplayString(new Date().getFullYear()) + " 南京艾科曼信息技术有限公司 ", 1)
      ])
    ])
  ]))
}